export default [
    {
		path: "/molar",
		component: () => import("../views/MOLAR/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	}
]
